import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Image, Input, Modal, Row, message } from 'antd';
import React, { useRef, useState } from 'react';
import { Images } from '../../../../controller/Images';
import { CopyOutlined } from '@ant-design/icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { createInvitation, createOpenLinkInvitation } from '../../../../controller/api/invitationServices';
import { getAdminDetail } from '../../../../controller/localStroageHandler';

const OpenTestLinkModal = ({ openTextLink, setOpenTextLink, testId, setTestID }) => {
    const [url, setUrl] = useState(null);
    const [otp, setOtp] = useState(null);
    const textRef = useRef(null);
    const userDetail = getAdminDetail();

    const handleCopy = () => {
        if (textRef.current) {
            const textToCopy = textRef.current.textContent;

            // Check if the Clipboard API is available
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard
                    .writeText(textToCopy)
                    .then(() => {
                        message.success('Text copied!');
                    })
                    .catch((error) => {
                        console.error('Failed to copy text: ', error);
                    });
            } else {
                // Fallback: create a temporary textarea and execute copy command
                const textarea = document.createElement('textarea');
                textarea.value = textToCopy;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                message.success('Text copied!');
            }
        }
    };

    const handleGenerateLink = (val) => {
        setUrl(null);
        setOtp(null);
        const payload = {
            testID: testId,
            test_link: window?.location?.origin,
        };
        createOpenLinkInvitation(payload, { id: userDetail?.organization_id?._id })
            .then((res) => {
                setUrl(res?.data?.link);
                message.success(res?.data?.message);
            })
            .catch((err) => message.info("Something went wrong"));
    }


    return (
        <Modal title='' open={openTextLink} closeIcon={null} footer={null} width={350}>
            <div className='d-flex flex-column justify-content-center align-items-center text-center pt-4 gap-3'>
                <div className='d-flex flex-column'>
                    <span className='fs-4 fw-semibold'>Generate Open Test Link</span>
                    <p className='fs-6 opacity-50'>Copy the link Below to share</p>
                </div>
                <div className='bg-white border border-color p-1 w-100 d-flex justify-content-between align-items-center rounded-1'>
                    <span
                        ref={textRef}
                        className='text-truncate test-link prevent-select text-muted fw-medium'
                        style={{ maxWidth: '200px', height: '27px' }}
                    >
                        {url}
                    </span>{' '}
                    <CopyOutlined
                        className={`${url == null ? 'disabled' : 'text-color-custom'}`}
                        onClick={() => handleCopy()}
                    />
                </div>
                <div className='w-100 text-start'>
                    <Button
                        type='primary'
                        htmlType='submit'
                        className='w-100 fs-6 fw-normal btn-border-color d-flex justify-content-center align-items-center button-color custom-hover-btn'
                        onClick={()=>handleGenerateLink()}
                    >
                        Generate Link
                    </Button>
                </div>
                <Row className='w-100' gutter={[12, 12]}>
                    <Col span={12}>
                        <Button
                            type='text'
                            className={`w-100 text-color-custom fs-6 fw-semibold d-flex justify-content-center align-items-center ${url != null && 'custom-hover-btn'
                                } gap-2`}
                            onClick={() => handleCopy()}
                            disabled={url != null ? false : true}
                        >
                            <FontAwesomeIcon icon={faLink} />
                            Copy Link
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button
                            type='default'
                            className='text-color-custom w-100 fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                            onClick={() => {
                                setOpenTextLink(false);
                            }}
                        >
                            Done
                        </Button>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default OpenTestLinkModal;
